import type { CompositionV3Ent } from '@revelio/data-access';

import type { AllSelectionListsWithSkillTaxonomyKey } from '../../../../../shared/selection-lists/types';
import {
  type Filter,
  FilterType,
  type PrimaryFilterId,
} from '../../types/filters';
import { getNumericIdFromNestedId } from '../get-numeric-id-from-nested-id';
import {
  getEntKindForGeoOrRicsLevelId,
  getEntKindForRoleLevelId,
  getEntKindForSkillLevelId,
} from './role-skill-ent-kind';

export const getCompositionV3Entities = ({
  primaryDimension,
  effectiveFilters,
}: {
  primaryDimension: PrimaryFilterId;
  effectiveFilters: Filter[];
}): CompositionV3Ent[] => {
  const primaryFilter = effectiveFilters.find(
    (filter) => filter.id === primaryDimension
  );

  if (!primaryFilter || primaryFilter.type !== FilterType.TREE) return [];

  return primaryFilter.selections
    .map((selection): CompositionV3Ent | null => {
      const levelId =
        selection.levelId as AllSelectionListsWithSkillTaxonomyKey;

      const fromGeo = getEntKindForGeoOrRicsLevelId(levelId);
      if (fromGeo) {
        const id = getNumericIdFromNestedId(String(selection.id));
        if (id === null) return null;
        return { EntType: fromGeo, EntID: id };
      }

      const roleKind = getEntKindForRoleLevelId(String(selection.levelId));
      if (roleKind) {
        const id = getNumericIdFromNestedId(String(selection.id));
        if (id === null) return null;
        return { EntType: roleKind, EntID: id };
      }

      const skillKind = getEntKindForSkillLevelId(String(selection.levelId));
      if (skillKind) {
        const id = getNumericIdFromNestedId(String(selection.id));
        if (id === null) return null;
        return { EntType: skillKind, EntID: id };
      }

      return null;
    })
    .filter((row): row is CompositionV3Ent => row !== null);
};
